import { $$, JNativeStatic } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { CheckBoxListPropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/CheckBoxList";
import { CheckBoxListLookupItem, CheckBoxListLookupItemPropertyValues, ICheckBoxListLookupItem } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/CheckBoxListLookupItem";

import "./CheckBoxListAgreeDisagree.scss";

export type CheckBoxListAgreeDisagreePropertyValues =
    CheckBoxListPropertyValues
    & {
    };

export type CheckBoxListAgreeDisagreeProperties = {
    [name in keyof CheckBoxListAgreeDisagreePropertyValues]: Property<CheckBoxListAgreeDisagreePropertyValues[name]>
};

export interface ICheckBoxListAgreeDisagree extends ICheckBoxListLookupItem, CheckBoxListAgreeDisagreeProperties
{
}

export class CheckBoxListAgreeDisagree extends CheckBoxListLookupItem implements ICheckBoxListAgreeDisagree
{
    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<CheckBoxListAgreeDisagreePropertyValues & CheckBoxListLookupItemPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                horizontal: true,
                lookupType: "CSQ Agree / Disagree Ratings",
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructors

    constructor(propertyValues?: PartialNullable<CheckBoxListAgreeDisagreePropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("gme-control-check-box-list-agree-disagree");
    }

    // #endregion

    // #region Protected Methods

    protected _getEmoji(description?: string)
    {
        switch (description?.toLowerCase())
        {
            case "strongly disagree":
                return "😠";
            case "disagree":
                return "😕";
            case "not sure":
                return "😐";
            case "agree":
                return "🙂";
            case "strongly agree":
                return "🙂";
        }
    }

    // #endregion

    // #region Overrides

    protected override _refreshListDataSource()
    {
        super._refreshListDataSource();

        const
            checkboxes = this.$$element.get()?.find(".checkbox");

        if (checkboxes)
        {
            for (const checkbox of checkboxes)
            {
                const
                    $$checkbox = $$(checkbox),
                    item = $$checkbox.data("rad-option");

                $$checkbox.find("label").prepend(JNativeStatic.create$$({ attributes: { class: "emoji" }, nodeName: "span", text: this._getEmoji(item.description) }));
            }
        }
    }

    // #endregion

    // #endregion
}